import { ReactNode } from 'react';
import { SingleSelectCheck } from '../../icons';
import { cn } from '../../utils';
import { CommandItem } from '../Command';
import { ComboboxOption } from './Combobox';

interface ComboboxCommandItemProps<
  V extends string | string[] | null = string,
  T extends Record<string, unknown> = {},
> {
  option: ComboboxOption<T>;
  isMultiSelect?: boolean;
  value?: V;
  key: string;
  toggleValue: (value: string) => void;
  onOptionSelect?: (o: ComboboxOption<T>) => void | boolean;
  setOpen?: (open: boolean) => void;
  OptionComponent: (o: ComboboxOption<T>) => ReactNode;
}

export function ComboboxCommandItem<
  V extends string | string[] | null = string,
  T extends Record<string, unknown> = {},
>({
  option,
  isMultiSelect,
  value,
  toggleValue,
  onOptionSelect,
  setOpen,
  OptionComponent,
}: ComboboxCommandItemProps<V, T>) {
  const { value: optionValue } = option;
  const checked = isMultiSelect
    ? (value as string[]).includes(optionValue)
    : optionValue === value;

  return (
    <CommandItem
      value={optionValue}
      onSelect={() => {
        const handled = onOptionSelect?.(option);
        if (handled !== true) toggleValue(optionValue);

        if (!isMultiSelect && setOpen) setOpen(false);
      }}
      className="flex items-center justify-between gap-2 px-4 py-2"
    >
      <OptionComponent {...option} />
      <SingleSelectCheck
        className={cn(
          'text-primary size-4 min-w-4 stroke-2 transition-all',
          checked ? '-mr-0 w-4 opacity-100' : '-mr-2 w-0 opacity-0'
        )}
      />
    </CommandItem>
  );
}
